/**
 * Token sesji admina do proxy (X-Proxy-Token) — po zalogowaniu, nie ze zmiennej builda.
 */
export function getProxySessionToken() {
  try {
    const raw = localStorage.getItem('admin_session');
    if (!raw) return '';
    const session = JSON.parse(raw);
    return session?.token || '';
  } catch {
    return '';
  }
}

export function getAdminLoginUrl() {
  const explicit = (process.env.REACT_APP_ADMIN_LOGIN_URL || '').trim();
  if (explicit) return explicit.replace(/\/$/, '');
  const proxyUrl = (process.env.REACT_APP_SUPABASE_PROXY_URL || '').trim();
  if (!proxyUrl) return '';
  return proxyUrl.replace(/\/supabase-proxy\.php$/i, '/admin-login.php');
}
